import { UserAvatar } from 'core/components/user';
import { useUser } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Button } from 'modules/cxi/components/button';
import { RHP } from 'providers';
import React from 'react';
import * as Styled from './styledAboutUser';

export const AboutUser = () => {
    const { t } = useTranslation('glossary');
    const user = useUser();

    return (
        <Styled.About>
            <Styled.Wrapper className="user">
                <Styled.UserProfile>{t('yourProfile')}</Styled.UserProfile>
                <Styled.AboutBody className="user">
                    <div className="user">
                        <UserAvatar />

                        <div className="infos">
                            <span className="name">{user.fullName}</span>
                            <span className="post">{user.email}</span>
                        </div>
                    </div>
                    <Button
                        className="about-button"
                        variant="blue"
                        size="medium"
                        onClick={() => RHP.push('/profile')}
                    >
                        <span className="text">{t('glossary:edit')}</span>
                    </Button>
                </Styled.AboutBody>
            </Styled.Wrapper>
        </Styled.About>
    );
};
